// ============================================================
// MOCK DATA — Abhi Insurance Agency (frontend-only version)
// All form submissions are stored in localStorage for now.
// Replace with real API calls during backend integration.
// ============================================================

export const COMPANY = {
  name: "Abhi Insurance",
  legalName: "Abhi Insurance Agency Inc.",
  tagline: "Protecting You Always",
  phone: "+1 (604) 996-6862",
  phoneAlt: "+1 (604) 227-9410",
  phoneHref: "tel:+16049966862",
  email: "info@abhifinancial.com",
  address: "Surrey, British Columbia, Canada",
  hours: "Open 7 Days a Week · 09:00 – 17:00",
  since: 2000,
  owner: "Sandeep Ahuja",
};

export const STATS = [
  { value: 25, suffix: "+", label: "Years of Trusted Service" },
  { value: 45, suffix: "%", label: "Premium Savings — Up To" },
  { value: 8, suffix: "x", label: "'Top of the Table' Designation" },
  { value: 7, suffix: "", label: "Days a Week Availability" },
];

export const CREDENTIALS = [
  "MDRT Member since 2010",
  "Advocis Member",
  "CHS Designation",
  "8x 'Top of the Table'",
  "Fully Licensed in BC",
  "5-Star Client Reviews",
];

export const SERVICES = [
  {
    slug: "super-visa-insurance",
    title: "Super Visa Insurance",
    short:
      "Mandatory medical coverage for parents and grandparents visiting Canada on the Super Visa program — with minimum $100,000 coverage from a Canadian insurer.",
    image: "https://images.pexels.com/photos/8317703/pexels-photo-8317703.jpeg",
    icon: "PlaneTakeoff",
    heroLine: "Extending your stay in Canada!",
    intro:
      "If you're planning an extended stay in Canada to visit your child or grandchild, you'll want to apply for the Super Visa — and to qualify, you'll need Super Visa Insurance. As your Super Visa insurance advisor, Abhi Insurance Agency partners with Canada's leading insurance companies to guarantee you the best rates and most trustworthy service possible.",
    sections: [
      {
        heading: "What is the Super Visa?",
        body: "The Super Visa allows a parent or grandparent of a Canadian citizen or permanent resident to visit their relative in Canada for up to 5 years at a time. The visa allows multiple entries and remains valid for up to 10 years.",
        bullets: [
          "Be the parent or grandparent of a Canadian citizen or permanent resident of Canada",
          "Have a written invitation from your child or grandchild living in Canada, including a promise of financial support",
          "Have Super Visa medical insurance from a Canadian insurance company",
        ],
      },
      {
        heading: "What is Super Visa Insurance?",
        body: "Super Visa insurance is the medical insurance you must hold for the duration of your extended stay. It guarantees you and your family can affordably access emergency medical care if anyone is injured or becomes ill during the visit.",
        bullets: [
          "Obtained from an insurance provider located in Canada",
          "Purchased prior to entering Canada",
          "Proof of payment shown when applying for the Super Visa",
          "Valid for at least 1 year from the date of entry",
          "Provides at least $100,000 in coverage",
        ],
      },
    ],
    why: [
      "FREE advice consultation with an expert Super Visa insurance advisor — by phone or in person",
      "No hidden fees, ever",
      "Experienced, friendly and patient agents",
      "We represent Canada's best insurance companies, providing reliable and affordable coverage since 2000",
    ],
    ctaText:
      "Contact us for a free consultation with one of our experienced Super Visa Insurance agents. We'll help you understand your options and choose the right policy from one of our leading insurance partners.",
  },
  {
    slug: "visitor-visa-insurance",
    title: "Visitor Visa Insurance",
    short:
      "Emergency medical protection for anyone visiting Canada — for a brief trip, an extended stay, or while waiting for provincial health coverage to begin.",
    image: "https://images.unsplash.com/photo-1504150558240-0b4fd8946624",
    icon: "Luggage",
    heroLine: "Prepare for the unexpected while you're traveling!",
    intro:
      "Visitor visa insurance is an important purchase for anyone planning to visit Canada — whether you're here for a brief visit, an extended stay, or if you plan to make Canada your new home. While you remain in the country, your visitor visa insurance keeps you protected in case of an accident or another emergency.",
    sections: [
      {
        heading: "Why do you need visitor visa insurance?",
        body: "Canada's universal health coverage only applies to citizens and lawful residents. If you're just visiting, or waiting for your Canadian health coverage to begin, you must be prepared with your own medical insurance. Without it, an accident or illness could cost you thousands of dollars.",
        bullets: [
          "Affordable protection against expensive emergency medical costs",
          "Some policies also cover you while traveling to and from Canada",
          "Side trips to other countries may also be covered",
        ],
      },
      {
        heading: "What type of coverage do you need?",
        body: "Our advisors recommend a policy that covers accidents and medical emergencies for the entire time you're in Canada — and even while you travel to and from the country. Working with a Canada-based agency ensures your coverage is comprehensive and your insurer knows Canada's health care system best.",
        bullets: [
          "Valid for your entire stay in Canada",
          "Coverage from a trusted Canadian insurer",
          "Expert guidance on the right coverage amount for your travel plans",
        ],
      },
    ],
    why: [
      "Experts at finding the best rates based on your budget and travel plans",
      "FREE consultation with a visitor visa insurance advisor",
      "Representing Canada's best insurance companies since 2000",
    ],
    ctaText:
      "Don't wait until it's too late! It's best to purchase your visitor visa insurance before you arrive in Canada. Contact us today to speak with a visitor visa insurance advisor.",
  },
  {
    slug: "life-insurance",
    title: "Life Insurance",
    short:
      "Protect your family from financial loss and give them the gift of security and peace of mind — with the right policy at the right rate.",
    image: "https://images.pexels.com/photos/7938055/pexels-photo-7938055.jpeg",
    icon: "HeartHandshake",
    heroLine: "The gift of financial security!",
    intro:
      "Life insurance is an essential purchase for anyone who provides for their family. Its most important purpose is to protect loved ones from financial loss when the wage earner dies — ensuring they remain in their home, pay bills and keep up with everyday expenses. With life insurance, you provide your family with the gift of financial security and peace of mind.",
    sections: [
      {
        heading: "Purchasing Life Insurance",
        body: "Purchasing life insurance can be intimidating or confusing, especially when you must consider multiple quotes from different companies with varying benefits and conditions. Abhi Insurance Agency takes the guesswork out of choosing life insurance — our advisors listen, research every available option, and advise you on which policies fit best.",
        bullets: [
          "We compare rates and benefits across Canada's most trusted insurers",
          "Clear, jargon-free explanations of every option",
          "No pressure — plenty of time to ask questions and decide",
        ],
      },
      {
        heading: "What to expect from your advisor",
        body: "Your friendly advisor will ask a few questions about your age, marital status, family and financial situation. Based on your budget and unique circumstances, they'll compare policies, explain your options in clear language, and purchase your policy only when you're fully confident.",
        bullets: [
          "Personalized needs analysis",
          "Side-by-side comparison of leading Canadian insurers",
          "Support available 7 days a week — even after you purchase",
        ],
      },
    ],
    why: [
      "Fully licensed life insurance agency",
      "FREE advice consultations — by phone or in person, no obligations",
      "No hidden fees, personalized advice and support",
      "Helping Canadians save on life insurance since 2000 — available 7 days a week",
    ],
    ctaText:
      "Contact us for a free consultation with one of our experienced Life Insurance agents. We'll help you understand your options and choose the right policy from one of our leading insurance partners.",
  },
  {
    slug: "critical-illness-insurance",
    title: "Critical Illness Insurance",
    short:
      "A lump-sum benefit upon diagnosis of a covered critical illness — so you can focus on recovery, not medical bills or lost income.",
    image: "https://images.pexels.com/photos/7578798/pexels-photo-7578798.jpeg",
    icon: "Activity",
    heroLine: "Focus on recovery, not finances!",
    intro:
      "A critical illness diagnosis can bring large, burdensome medical expenses and the loss of regular wages. Critical illness insurance provides a lump-sum payment upon diagnosis of a covered condition, giving you and your family the financial security and peace of mind you need during one of life's most unexpected events.",
    sections: [
      {
        heading: "Why do you need critical illness insurance?",
        body: "When you prepare with critical illness coverage, you protect your family's finances from the ripple effects of a serious diagnosis — from treatment costs to everyday bills.",
        bullets: [
          "No worrying about expensive medical bills or growing debt",
          "Access the very best care and medications that may not be covered by government health plans",
          "Replace lost or reduced income if you or your spouse cannot work",
          "Afford professional help around the house while you cope with your illness",
          "Focus fully on your recovery",
        ],
      },
      {
        heading: "What's covered?",
        body: "The conditions covered differ from insurer to insurer — many plans cover cancers, heart conditions and stroke at various severity levels. Our advisors help you compare what is (and isn't) covered, choose an adequate coverage amount, and weigh factors like claim settlement history and service quality — not just price.",
        bullets: [
          "Coverage comparison across leading Canadian insurers",
          "Guidance on the right coverage size for your financial situation",
          "Transparent explanation of exclusions before you buy",
        ],
      },
    ],
    why: [
      "FREE advice consultation with an expert critical illness advisor — by phone or in person",
      "Experienced, friendly and patient agents",
      "No hidden fees",
      "Reliable and affordable coverage from Canada's best insurers since 2000",
    ],
    ctaText:
      "Still not sure critical illness insurance is the right solution for you? Call us today for a free consultation with an experienced critical illness insurance advisor.",
  },
  {
    slug: "disability-insurance",
    title: "Disability Insurance",
    short:
      "Income protection if illness or injury keeps you from working — covering your expenses with a temporary monthly income.",
    image: "https://images.unsplash.com/photo-1570793005299-c091be91bbad",
    icon: "ShieldCheck",
    heroLine: "Protect your most valuable asset — your income!",
    intro:
      "If you become ill or are injured in an accident and can no longer work, disability insurance covers your expenses and pays a temporary monthly income. It's essential protection for any working person, shielding you and your loved ones from the unexpected financial losses a disability can cause.",
    sections: [
      {
        heading: "Why disability insurance matters",
        body: "Your ability to earn an income is likely your most valuable financial asset. A disability — even a temporary one — can interrupt that income for months or years. Disability insurance bridges the gap so your family's lifestyle and savings stay protected.",
        bullets: [
          "Monthly benefit replaces a portion of your income while you can't work",
          "Covers everyday living expenses, bills and commitments",
          "Options for both short-term and long-term protection",
        ],
      },
      {
        heading: "Finding the right plan",
        body: "When you consult with your disability insurance advisor, share as much information about your financial circumstances as possible — your income, typical bills and living expenses, and the amount you can afford for coverage. We'll find the right plan that fits your needs now and in the future.",
        bullets: [
          "Personalized needs and budget assessment",
          "Comparison of waiting periods, benefit periods and definitions of disability",
          "Clear advice with no pressure",
        ],
      },
    ],
    why: [
      "FREE consultation with an experienced disability insurance advisor",
      "No hidden fees",
      "Tailored recommendations for your income and lifestyle",
      "Trusted by Canadian families since 2000",
    ],
    ctaText:
      "If you'd like to consider your options for disability insurance, contact us today. We'll look for the right plan that fits your financial needs now and in the future.",
  },
];

export const WHY_CHOOSE = [
  { icon: "MessagesSquare", title: "Free Advice Consultations", text: "Speak with an insurance advisor over the phone or in person — completely free, with no obligations." },
  { icon: "BadgeCheck", title: "No Hidden Fees", text: "Total transparency from your first consultation to your final policy. What we quote is what you pay." },
  { icon: "UserCheck", title: "In-House Claim Assistance", text: "A dedicated claim assistance manager works directly with clients when you need support most." },
  { icon: "Clock", title: "Same-Day Partial Refunds", text: "Partial refunds are processed on the very same day. Your money moves as fast as you do." },
  { icon: "Star", title: "5-Star Rated Service", text: "Consistently rated 5 stars by our satisfied clients across Surrey and the Lower Mainland." },
  { icon: "Trophy", title: "Industry Recognition", text: "Designated 'Top of the Table' 8 times, MDRT member since 2010, Advocis member with CHS designation." },
];

export const TESTIMONIALS = [
  {
    name: "Doug Ramsey",
    role: "Criminal Lawyer",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
    text: "I am so pleased and satisfied with this insurance company's service. It is so great to work with an adviser who is truly interested in their client's needs, goals and preferences. I am really impressed with their commitment.",
  },
  {
    name: "Bessie Sanders",
    role: "Production Manager",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956",
    text: "They have assembled only certified and experienced advisors who stand behind their promise to deliver quality and timely services. It is so great to work with specialists who are truly interested in their client's needs and goals.",
  },
  {
    name: "Sara Garcia",
    role: "School Teacher",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a",
    text: "I want to express how grateful I am for the work you have done for my family over the past years. They work through the process to identify your needs, goals and strategy, and put your plan into action!",
  },
];

export const ADVISOR = {
  name: "Sandeep Ahuja",
  role: "Founder & Licensed Insurance Advisor",
  image: "https://images.pexels.com/photos/37148308/pexels-photo-37148308.jpeg",
  bio: "Since 2000, Sandeep Ahuja has been helping Canadians, Canadian immigrants and visitors with all their insurance needs. A fully licensed insurance advisor, MDRT member since 2010 and 8-time 'Top of the Table' designee, Sandeep is an expert at providing clients with tailored advice — comparing the benefits and drawbacks of plans across companies so every client is confident they have the best possible coverage for their needs and budget.",
  highlights: ["MDRT Member since 2010", "8x 'Top of the Table'", "Advocis Member", "CHS Designation"],
};

export const BLOG_POSTS = [
  {
    slug: "super-visa-insurance-requirements-guide",
    title: "Super Visa Insurance Requirements: A Complete Guide for Parents & Grandparents",
    category: "Super Visa",
    date: "July 14, 2025",
    readTime: "6 min read",
    image: "https://images.pexels.com/photos/8317705/pexels-photo-8317705.jpeg",
    excerpt:
      "Planning to bring your parents or grandparents to Canada for an extended stay? Here's everything you need to know about Super Visa insurance requirements — coverage minimums, validity rules, and how to qualify.",
    content: [
      { type: "p", text: "The Super Visa lets parents and grandparents of Canadian citizens or permanent residents visit Canada for up to 5 years at a time, with multiple entries over a period of up to 10 years. One of the key requirements is proof of medical insurance from an approved insurer." },
      { type: "h3", text: "The core insurance requirements" },
      { type: "ul", items: ["Coverage of at least $100,000 for health care, hospitalization and repatriation", "Valid for at least 1 year from the date of entry into Canada", "Purchased from a Canadian insurance company (or an approved provider)", "Proof of full or instalment payment when applying"] },
      { type: "h3", text: "When should you buy it?" },
      { type: "p", text: "You must purchase the insurance before entering Canada, and you'll need to show proof of payment as part of the Super Visa application. Buying early also gives you time to compare providers and lock in a better rate." },
      { type: "h3", text: "How to save on premiums" },
      { type: "ul", items: ["Compare multiple Canadian insurers — rates vary significantly for the same coverage", "Consider a deductible to lower the premium", "Ask about monthly instalment payment options", "Work with a licensed advisor who can access preferred rates"] },
      { type: "p", text: "At Abhi Insurance Agency, we compare Canada's leading Super Visa insurance providers so you get reliable coverage at the best available rate — with free consultations 7 days a week." },
    ],
  },
  {
    slug: "choosing-critical-illness-insurance-plan",
    title: "What You Need To Know Before Choosing a Critical Illness Insurance Plan",
    category: "Critical Illness",
    date: "June 28, 2025",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1637763723578-79a4ca9225f7",
    excerpt:
      "Critical illness insurance offers a lump sum upon diagnosis — but coverage differs from insurer to insurer. Here are the key points to review before you buy.",
    content: [
      { type: "p", text: "Critical illness insurance pays a lump sum of money to the insured person upon diagnosis of a covered condition. Diseases that can leave a person permanently affected — forcing financial, emotional and physical dependence on others — typically fall under critical illness coverage." },
      { type: "p", text: "There is no universal list of covered illnesses: what's included differs from insurer to insurer. Some plans cover cancers and heart-related conditions across all severity levels, while others are more limited." },
      { type: "h3", text: "Key points to consider before buying" },
      { type: "ul", items: ["Check exactly which diseases are covered — and conduct a self-assessment to choose a plan suited to your health needs", "Choose an adequate coverage size for your financial situation; treatment for conditions like cancer and heart disease can be very costly", "Look carefully at what has NOT been covered in the policy — exclusions matter as much as inclusions", "Don't decide on cost alone — consider claim settlement ratio, number of ailments covered, and the insurer's service quality"] },
      { type: "p", text: "This policy isn't just for a particular group — it's ideal for all working people, because health conditions can change unexpectedly and medical expenses can wipe out life-long savings." },
    ],
  },
  {
    slug: "denied-life-insurance-what-to-do-next",
    title: "Denied Life Insurance? Here's What To Do Next",
    category: "Life Insurance",
    date: "June 10, 2025",
    readTime: "4 min read",
    image: "https://images.pexels.com/photos/7876501/pexels-photo-7876501.jpeg",
    excerpt:
      "A declined application isn't the end of the road. Three practical steps to take if a life insurance company has denied your request.",
    content: [
      { type: "p", text: "If a life insurance company denied your application, you may fall into what insurers call the 'impaired risk market.' Understandably, a denial is discouraging — but it doesn't mean your hunt for approval is over. You can apply to a more suitable company or for a different type of policy." },
      { type: "h3", text: "1. Collect information" },
      { type: "p", text: "Insurers collect data from many sources to evaluate risk. Request detailed information on why your application was denied — the answer can sometimes surprise you, and it tells you exactly what to address." },
      { type: "h3", text: "2. Confirm the results" },
      { type: "p", text: "Mistakes happen. Double-check the data you collected from the insurer. If the decline was based on a poor or incorrect exam result, confirm it with an expert physician. Also make sure your financial and personal profile is updated and accurate." },
      { type: "h3", text: "3. Work with an experienced agent" },
      { type: "p", text: "An experienced insurance agent can help you find better options and apply to insurers whose underwriting rules fit your situation. Every insurance company has its own rules — an advisor who knows them can make all the difference. If the reason for denial is too strong, a different type of policy may be the right path." },
    ],
  },
  {
    slug: "how-much-life-insurance-do-you-need",
    title: "How Much Life Insurance Do You Actually Need? A Simple Canadian Guide",
    category: "Life Insurance",
    date: "May 22, 2025",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1631651693480-97f1132e333d",
    excerpt:
      "A practical framework for calculating your life insurance coverage — debts, income replacement, education costs and final expenses.",
    content: [
      { type: "p", text: "One of the most common questions we hear is: 'How much life insurance do I really need?' While everyone's situation is unique, a helpful starting framework is often called the DIME method." },
      { type: "h3", text: "The DIME framework" },
      { type: "ul", items: ["Debt — total your outstanding debts (excluding mortgage): loans, credit cards, car payments", "Income — multiply your annual income by the number of years your family would need support (often 10+)", "Mortgage — the amount needed to pay off your mortgage completely", "Education — estimated future education costs for each child"] },
      { type: "p", text: "Adding these together gives a reasonable estimate of the coverage your family would need to maintain their lifestyle without your income." },
      { type: "h3", text: "Other factors to weigh" },
      { type: "ul", items: ["Existing coverage through your employer (often not portable if you change jobs)", "Your spouse's income and earning potential", "Final expenses and estate costs", "Whether term or permanent coverage suits your goals and budget"] },
      { type: "p", text: "A licensed advisor can run these numbers with you in minutes — and compare policies across Canada's top insurers to find the right fit. Consultations with Abhi Insurance Agency are always free." },
    ],
  },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Services", to: "/services", dropdown: true },
  { label: "Insights", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export const DISCLAIMER =
  "Disclaimer: The information on this website is provided for general informational purposes only and does not constitute financial, legal or insurance advice. Insurance products, eligibility requirements, government program rules (including Super Visa requirements) and rates are subject to change and vary by individual circumstances. Please consult a licensed insurance advisor and refer to official Government of Canada (IRCC) resources before making any decisions.";

// -------- localStorage helpers (MOCK persistence) --------
const read = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key)) || [];
  } catch {
    return [];
  }
};

export const saveQuoteRequest = (data) => {
  const all = read("abhi_quote_requests");
  all.push({ ...data, id: Date.now(), createdAt: new Date().toISOString() });
  localStorage.setItem("abhi_quote_requests", JSON.stringify(all));
  return true;
};

export const saveContactMessage = (data) => {
  const all = read("abhi_contact_messages");
  all.push({ ...data, id: Date.now(), createdAt: new Date().toISOString() });
  localStorage.setItem("abhi_contact_messages", JSON.stringify(all));
  return true;
};

export const saveNewsletter = (email) => {
  const all = read("abhi_newsletter");
  all.push({ email, id: Date.now(), createdAt: new Date().toISOString() });
  localStorage.setItem("abhi_newsletter", JSON.stringify(all));
  return true;
};
